import { useCallback } from 'react';

import { useLogIn } from '@hooks/useLogIn';
import { toExtendedUser } from '@shared/utils/user';

import { useCreateGuestMutation } from '@store/api/user.api';

export function useGetGuest() {
  const logIn = useLogIn();
  const [mutation, { isLoading }] = useCreateGuestMutation();

  const getGuest = useCallback(async () => {
    try {
      const { payload, token } = await mutation().unwrap();
      logIn(payload, token);

      return toExtendedUser(payload);
    } catch (err) {
      return null;
    }
  }, []);

  return [getGuest, { isLoading }] as const;
}
